import React from "react";

export default function About() {
  return (
    <main className="container-civic py-16 max-w-3xl">
      <div className="label-overline">Despre</div>
      <h1 className="font-display text-4xl md:text-6xl font-black tracking-[-0.02em] mt-3">
        fără hârtie<span className="text-[#00D670]">.</span>ro
      </h1>
      <p className="mt-6 text-base text-foreground/80 leading-relaxed">
        Suntem o platformă civică independentă care leagă voturile cetățenilor de
        deciziile autorităților locale. Nu publicăm cereri de la sertar și nu
        favorizăm pe nimeni: orice proiect listat aici are un destinatar clar – o
        primărie, un consiliu județean, un inspectorat.
      </p>

      <h2 className="font-display text-2xl font-bold mt-12">Ce facem cu voturile</h2>
      <p className="mt-3 text-foreground/80 leading-relaxed">
        La final de lună, generăm un raport public cu proiectele cele mai votate
        din fiecare județ și îl trimitem oficial către autoritatea destinatară.
        Răspunsurile sunt publicate aici, alături de proiect.
      </p>

      <h2 className="font-display text-2xl font-bold mt-12">Cum votezi corect</h2>
      <ul className="mt-3 space-y-3 text-foreground/80">
        <li>1. Un cont = un vot per proiect.</li>
        <li>2. Poți să-ți schimbi votul oricând – contează ultima opțiune.</li>
        <li>3. Susții <span className="font-semibold">orice</span> proiect din țară, nu doar din județul tău.</li>
      </ul>

      <h2 className="font-display text-2xl font-bold mt-12">Contact</h2>
      <p className="mt-3 text-foreground/80">
        Vrei să propui un proiect? Scrie-ne la <a href="mailto:contact@farahartie.ro" className="underline">contact@farahartie.ro</a> și echipa noastră îl evaluează în maxim 3 zile lucrătoare.
      </p>
    </main>
  );
}
